//聊天记录的数据类
export default class ChatRecordData {
    playerId:number = null
    playerName:string = null
    playerHeadSprite = null
    chatShowText:string = null

    myselfId:number = null

    constructor(_playerId:number,_playerName:string,_playerHeadSprite,_chatShowText:string,_myselfId:number){
        this.playerId = _playerId
        this.playerName = _playerName
        this.playerHeadSprite = _playerHeadSprite
        this.chatShowText = _chatShowText
        this.myselfId = _myselfId
    }
}